/**
 * Specifies the default number of days available to select for
 * the delivery date of an order staring from the minimum day.
 */
export const ORDER_BUILDER_AVAILABLE_DAYS_FROM_MIN = 30;
export const ORDER_BUILDER_MAX_SPACING = 720;
